module.exports = __webpack_public_path__ + "img/offensive_kodo_small.192ae479.png";